import { render } from "./base-multi-checkbox.vue?vue&type=template&id=6299bfe1&ts=true"
import script from "./base-multi-checkbox.vue?vue&type=script&lang=ts"
export * from "./base-multi-checkbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__